import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../GlobalDataContext/GlobalContext";
import {
  encryptString,
  createSession,
  getAbhaProfile,
} from "../../services/apiUtils";
import Loader from "../../components/common/Loader";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import { toast, ToastContainer } from "react-toastify";
import DeactivatePopup from "../../components/Forgot-ABHA/Account-deactivate-popup";

const LoginABHANumber = () => {
  const [showOtpBox, setShowOtpBox] = useState(false);
  const [formateAbha, setFormateAbha] = useState("");
  const [abhano, setAbhano] = useState("");
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [accessToken, setaccessToken] = useState("");
  const [txnId, settxnId] = useState("");
  const [resendTimer, setResendTimer] = useState("");
  const [OtpText, setOtpText] = useState("");
  const [showDeactivateMessage, setShowDeactivateMessage] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaSessionId, setCaptchaSessionId] = useState("");
  const [captchaImage, setCaptchaImage] = useState("");
  const [showAbha, setShowAbha] = useState(false);
  const [resendCount, setResendCount] = useState(1);
  const [abhaError, setAbhaError] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpSystem, setOtpSystem] = useState("");
  const navigate = useNavigate();

  const { getDataByKey } = useContext(GlobalContext);
  const back = () => {
    if (showOtpBox) {
      setShowOtpBox(false);
      setResendCount(1);
    } else {
      getDataByKey("backfunction")?.();
    }
  };

  // Fetch captcha from backend
  const generateCaptcha = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/abha/captcha/generate`);
      if (response.data.success) {
        setCaptchaSessionId(response.data.data.sessionId);
        setCaptchaImage(response.data.data.captchaImage);
        setCaptchaInput("");
      } else {
        toast.error("Failed to generate captcha. Please try again.");
      }
    } catch (error) {
      console.error("Error generating captcha:", error);
      toast.error("Failed to generate captcha. Please try again.");
    }
  };

  // Toggle ABHA visibility
  const toggleAbhaVisibility = () => {
    setShowAbha(!showAbha);
    // Reformat the display
    if (!showAbha && abhano) {
      // Switching to visible - show formatted number
      const formatted = abhano.replace(
        /^(\d{2})(\d{0,4})(\d{0,4})(\d{0,4}).*/,
        (match, p1, p2, p3, p4) => [p1, p2, p3, p4].filter(Boolean).join("-"),
      );
      setFormateAbha(formatted);
    } else if (abhano) {
      // Switching to masked - show all asterisks
      const maskedValue = abhano
        .split("")
        .map(() => "*")
        .join("");
      setFormateAbha(maskedValue);
    }
  };

  // Initialize captcha on mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  /**
   * function used to formate ABHA no. in input box with mask/unmask support
   */
  const handleFormateAbha = (e) => {
    const inputValue = e.target.value;

    if (showAbha) {
      // When visible, extract numeric values directly
      const numericValue = inputValue.replace(/\D/g, "");
      const limitedValue = numericValue.slice(0, 14);
      setAbhano(limitedValue);
      // Format as xx-xxxx-xxxx-xxxx
      const formatted = limitedValue.replace(
        /^(\d{2})(\d{0,4})(\d{0,4})(\d{0,4}).*/,
        (match, p1, p2, p3, p4) => [p1, p2, p3, p4].filter(Boolean).join("-"),
      );
      setFormateAbha(formatted);

      // Validate ABHA number
      if (limitedValue.length === 0) {
        setAbhaError("ABHA number is required");
      } else if (limitedValue.length < 14) {
        setAbhaError("ABHA number must be 14 digits");
      } else {
        setAbhaError("");
      }
    } else {
      // When masked, compare lengths to determine if adding or removing
      const currentLength = formateAbha.length;
      const newLength = inputValue.length;

      if (newLength > currentLength) {
        // User is adding a digit - extract the new digit
        const newDigit = inputValue.replace(/\D/g, "").slice(-1);
        if (newDigit && abhano.length < 14) {
          const updatedValue = abhano + newDigit;
          setAbhano(updatedValue);
          const maskedValue = updatedValue
            .split("")
            .map(() => "*")
            .join("");
          setFormateAbha(maskedValue);
        } else {
          // No new digit, just restore the mask
          const maskedValue = abhano
            .split("")
            .map(() => "*")
            .join("");
          setFormateAbha(maskedValue);
        }
      } else if (newLength < currentLength) {
        // User is removing a digit (backspace)
        const updatedValue = abhano.slice(0, -1);
        setAbhano(updatedValue);
        const maskedValue = updatedValue
          .split("")
          .map(() => "*")
          .join("");
        setFormateAbha(maskedValue);
      }

      // Validate ABHA number for masked input
      const currentAbhaLength =
        abhano.length + (newLength > currentLength ? 1 : -1);
      if (currentAbhaLength === 0) {
        setAbhaError("ABHA number is required");
      } else if (currentAbhaLength < 14) {
        setAbhaError("ABHA number must be 14 digits");
      } else {
        setAbhaError("");
      }
    }
  };
  /**
   * Function used to set otp text
   */
  const handleOtpChange = (e) => {
    const value = e.target.value;
    // Allow only digits and up to 6 characters
    if (/^\d{0,6}$/.test(value)) {
      setOtpText(value);
    }
  };

  // Countdown logic using useEffect
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
      return () => clearTimeout(timer); // Cleanup timer on unmount
    }
  }, [resendTimer]);

  /**
   * function used to send otp for abha verification
   */
  const handleSendOtp = async (event) => {
    event.preventDefault();

    // Validate OTP system selection first
    if (!otpSystem) {
      toast.error("Please select an OTP verification method.");
      return;
    }

    // Validate captcha with backend
    if (!captchaInput || captchaInput.trim() === "") {
      toast.error("Please enter the captcha.");
      return;
    }

    try {
      // Verify captcha with backend
      const captchaResponse = await axios.post(
        `${API_BASE_URL}/abha/captcha/validate`,
        {
          sessionId: captchaSessionId,
          captcha: captchaInput,
        },
      );

      if (!captchaResponse.data.success || !captchaResponse.data.valid) {
        toast.error("Invalid captcha. Please try again.");
        generateCaptcha(); // Regenerate captcha
        setCaptchaInput(""); // Clear input
        return;
      }
    } catch (error) {
      toast.error("Failed to validate captcha. Please try again.");
      generateCaptcha();
      setCaptchaInput("");
      return;
    }

    setIsPageLoading(true);
    try {
      // Format ABHA number as xx-xxxx-xxxx-xxxx
      const formattedAbhaNumber = abhano.replace(
        /^(\d{2})(\d{4})(\d{4})(\d{4})$/,
        "$1-$2-$3-$4",
      );
      // Encrypt ABHA number
      const encryptedAbhano = await encryptString(formattedAbhaNumber);
      if (encryptedAbhano) {
        // const sessionResponse = await createSession();
        // if (sessionResponse?.accessToken) {
          const url = `${API_BASE_URL}/abha/login/abha/number/send-otp`;
          const param = {
            abhaNumber: encryptedAbhano,
            verify:
              otpSystem === "aadhaar" ? "aadhaar-verify" : "mobile-verify",
            otpsystem: otpSystem === "aadhaar" ? "aadhaar" : "abdm",
          };
          // const accessToken = sessionResponse.accessToken;
          // setaccessToken(accessToken);
          const header = {
            headers: {
              "Content-Type": "application/json",
              // accesstoken: sessionResponse.accessToken,
            },
          };
          const response = await axios.post(url, param, header);
          const dtResponse = response.data;
          if (dtResponse.success) {
            settxnId(dtResponse.data?.txnId);
            setShowOtpBox(true);
            setResendTimer(60);

            toast.success(dtResponse?.data.message || "OTP sent successfully.");
            setIsPageLoading(false);
          } else {
            toast.error(
              dtResponse?.data.message ||
                "Failed to send OTP. Please try again.",
            );
            setIsPageLoading(false);
          }
        // } else {
        //   toast.error("Session creation failed. Please try again.");
        //   setIsPageLoading(false);
        // }
      } else {
        toast.error("Failed to encrypt ABHA number. Please try again.");
      }
    } catch (error) {
      setIsPageLoading(false);
      const errorMsg =
        error.response?.data?.error?.error?.message ||
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Server error occurred. Please try again later.";

      if (
        error.response?.data?.success === false &&
        error.response?.data?.message === "Unclassified Authentication Failure"
      ) {
        toast.error(errorMsg + ". Please try again!");
      } else if (
        error.response?.data?.success === false &&
        error.response?.data?.message ===
          "This account is deactivated. Please continue to reactivate."
      ) {
        setShowDeactivateMessage(errorMsg);
      } else {
        toast.error(errorMsg);
      }
    }
  };

  /**
   * Function used to resend OTP
   */
  const handleResendOtp = async () => {
    if (resendCount >= 3) {
      toast.error("Maximum resend attempts reached.");
      return;
    }
    if (resendTimer > 0) {
      toast.error("Please wait before resending OTP.");
      return;
    }

    setIsPageLoading(true);
    try {
      // Format ABHA number as xx-xxxx-xxxx-xxxx
      const formattedAbhaNumber = abhano.replace(
        /^(\d{2})(\d{4})(\d{4})(\d{4})$/,
        "$1-$2-$3-$4",
      );
      const encryptedAbhano = await encryptString(formattedAbhaNumber);
      if (encryptedAbhano) {
        // const sessionResponse = await createSession();
        // if (sessionResponse?.accessToken) {
          const url = `${API_BASE_URL}/abha/login/abha/number/send-otp`;
          const param = {
            abhaNumber: encryptedAbhano,
            verify:
              otpSystem === "aadhaar" ? "aadhaar-verify" : "mobile-verify",
            otpsystem: otpSystem === "aadhaar" ? "aadhaar" : "abdm",
          };
          const header = {
            headers: {
              "Content-Type": "application/json",
              // accesstoken: sessionResponse.accessToken,
            },
          };
          const response = await axios.post(url, param, header);
          const dtResponse = response.data;
          if (dtResponse.success) {
            settxnId(dtResponse.data?.txnId);
            setResendTimer(60);
            setResendCount(resendCount + 1);
            toast.success(
              dtResponse.data.message || "OTP resent successfully.",
            );
            setIsPageLoading(false);
          } else {
            toast.error(
              dtResponse?.data.message ||
                "Failed to resend OTP. Please try again.",
            );
            setIsPageLoading(false);
          }
        // } else {
        //   toast.error("Session creation failed. Please try again.");
        //   setIsPageLoading(false);
        // }
      } else {
        toast.error("Failed to encrypt ABHA number. Please try again.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      toast.error(
        error.response?.data?.message ||
          "Failed to resend OTP. Please try again.",
      );
    }
  };

  /**
   * Functin used to verify abha number
   */
  const verifyOtp = async (event) => {
    event.preventDefault();
    setIsPageLoading(true);
    try {
      const encryptedOtp = await encryptString(OtpText);
      if (encryptedOtp) {
        const url = `${API_BASE_URL}/abha/login/abha/number/verify-otp`;
        const param = {
          txnId: txnId,
          otp: encryptedOtp,
          verify: otpSystem === "aadhaar" ? "aadhaar-verify" : "mobile-verify",
        };
        const header = {
          headers: {
            "Content-Type": "application/json",
            // accesstoken: accessToken,
          },
        };
        const response = await axios.post(url, param, header);
        const dtResponse = response.data;

        if (dtResponse.success) {
          if (dtResponse.data.authResult === "success") {
            // localStorage.setItem("x_token", dtResponse.data.token);
            localStorage.setItem("loginMethod", "abhaNumber");
            // get ABHA profile data
            const abhaProfileData = await getAbhaProfile(
              // accessToken,
              null,
              dtResponse.data.token,
            );

            if (abhaProfileData?.success) {
              localStorage.setItem(
                "orignalBeneficiaryData",
                JSON.stringify(abhaProfileData?.data),
              );
              localStorage.setItem(
                "abhaProfileData",
                JSON.stringify(abhaProfileData),
              );
              setIsPageLoading(false);
              navigate("/abha-Card");
            } else {
              toast.error(
                abhaProfileData?.message ||
                  "Failed to fetch ABHA profile data. Please try again.",
              );
              setIsPageLoading(false);
              return;
            }
          } else {
            toast.error(
              dtResponse?.data?.message || "Wrong OTP. Please try again.",
            );
            setIsPageLoading(false);
            return;
          }
        } else {
          toast.error(
            dtResponse?.data?.message ||
              "Failed to verify OTP. Please try again.",
          );
          setIsPageLoading(false);
        }
      } else {
        toast.error("Failed to encrypt OTP. Please try again.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      // Backend returned an error response
      if (
        error.response.data.success === false &&
        error.response.data.message === "Unclassified Authentication Failure"
      ) {
        toast.error(error.response.data.message + ". Please try again!");
      } else {
        toast.error(
          error.response.data.message ||
            "Server error occurred. Please try again later.",
        );
      }
    }
  };
  return (
    <>
      {showDeactivateMessage && (
        <DeactivatePopup
          onClose={() => setShowDeactivateMessage("")}
          showDeactivateMessage={showDeactivateMessage}
        />
      )}
      <ToastContainer />
      {isPageLoading && <Loader />}
      <div className="flow-feilds">
        {!showOtpBox && (
          <>
            <div className="feilds">
              <label>
                Enter ABHA Number <span style={{ color: "red" }}>*</span>
              </label>
              <div style={{ position: "relative", width: "100%" }}>
                <input
                  type="text"
                  className="filds-form"
                  placeholder="xx-xxxx-xxxx-xxxx"
                  value={formateAbha}
                  autoComplete="off"
                  onChange={handleFormateAbha}
                  maxLength={17}
                  style={{ paddingRight: "40px", width: "100%" }}
                />
                <i
                  className="material-icons"
                  onClick={toggleAbhaVisibility}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "20px",
                  }}
                >
                  {showAbha ? "visibility" : "visibility_off"}
                </i>
              </div>
              {abhaError && (
                <span
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "5px",
                    display: "block",
                  }}
                >
                  {abhaError}
                </span>
              )}
            </div>

            <div className="feilds" style={{ marginTop: "15px" }}>
              <label>
                Validate using <span style={{ color: "red" }}>*</span>
              </label>
              <div style={{ display: "flex", gap: "30px", marginTop: "10px" }}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="radio"
                    name="otpSystem"
                    value="aadhaar"
                    checked={otpSystem === "aadhaar"}
                    onChange={(e) => setOtpSystem(e.target.value)}
                  />
                  OTP on mobile number linked with Aadhaar number
                </label>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="radio"
                    name="otpSystem"
                    value="abdm"
                    checked={otpSystem === "abdm"}
                    onChange={(e) => setOtpSystem(e.target.value)}
                  />
                  OTP on mobile number linked with ABHA number
                </label>
              </div>
            </div>

            <div className="feilds" style={{ marginTop: "15px" }}>
              <label>
                Captcha <span style={{ color: "red" }}>*</span>
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#f0f0f0",
                    padding: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    flex: 1,
                    textAlign: "center",
                    userSelect: "none",
                    minHeight: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {captchaImage ? (
                    <img
                      src={captchaImage}
                      alt="Captcha"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  ) : (
                    <span style={{ color: "#999" }}>Loading captcha...</span>
                  )}
                </div>
                <i
                  className="material-icons"
                  onClick={generateCaptcha}
                  style={{ cursor: "pointer", fontSize: "24px" }}
                  title="Refresh Captcha"
                >
                  refresh
                </i>
              </div>
              <input
                type="text"
                className="filds-form"
                placeholder="Enter captcha text"
                value={captchaInput}
                onChange={(e) => {
                  setCaptchaInput(e.target.value);
                }}
                autoComplete="off"
              />
            </div>
          </>
        )}
        {showOtpBox && (
          <>
            <div className="feilds">
              <label>ABHA Number</label>
              <input
                type="text"
                className="filds-form"
                value={
                  abhano.length === 14 ? `**-****-****-${abhano.slice(-4)}` : ""
                }
                disabled
                style={{ background: "#f5f5f5", cursor: "not-allowed" }}
              />
            </div>
            <div className="feilds">
              <label>
                Confirm OTP <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="filds-form"
                placeholder="Enter 6 digit OTP"
                value={OtpText}
                autoComplete="off"
                maxLength={6}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  handleOtpChange({ target: { value } });
                  if (value.length === 0) {
                    setOtpError("OTP is required");
                  } else if (value.length < 6) {
                    setOtpError("OTP must be 6 digits");
                  } else {
                    setOtpError("");
                  }
                }}
              />
              {otpError && (
                <span
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "5px",
                    display: "block",
                  }}
                >
                  {otpError}
                </span>
              )}
              <span
                className="notes text-end"
                onClick={
                  resendTimer === 0 && resendCount < 3 ? handleResendOtp : null
                }
                style={{
                  pointerEvents:
                    resendTimer > 0 || resendCount >= 3 ? "none" : "auto",
                  color:
                    resendTimer > 0 || resendCount >= 3 ? "#999" : "#007bff",
                  cursor:
                    resendTimer > 0 || resendCount >= 3
                      ? "not-allowed"
                      : "pointer",
                  display: "block",
                  marginTop: "5px",
                }}
              >
                {resendTimer > 0
                  ? `00:${resendTimer < 10 ? "0" + resendTimer : resendTimer} Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`
                  : resendCount >= 3
                    ? "Maximum resend attempts reached"
                    : `Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`}
              </span>
            </div>
          </>
        )}
      </div>

      <div className="flow-feilds" style={{ minHeight: "auto" }}>
        <div className="feilds feildsBtn">
          <button className="custBtn btnCancel" onClick={back}>
            Back
          </button>
          {!showOtpBox ? (
            <button
              className={`custBtn ${abhano.length === 14 && captchaInput.length > 0 ? "btnSuccess" : "disabled"}`}
              disabled={abhano.length !== 14 || captchaInput.length === 0}
              onClick={handleSendOtp}
            >
              Continue <i className="material-icons">arrow_right_alt</i>
            </button>
          ) : (
            <button
              className={`custBtn ${OtpText.length === 6 ? "btnSuccess" : "disabled"}`}
              disabled={OtpText.length !== 6}
              onClick={verifyOtp}
            >
              Verify <i className="material-icons">arrow_right_alt</i>
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default LoginABHANumber;
